import React from 'react';
import {Route, Redirect} from 'react-router-dom';
import {roles} from "../constants";

export const PrivateRoutes = ({component: Component, ...rest}) => (
    <Route {...rest} render={props => {
        if (rest.auth && !localStorage.accessToken) {
            // not logged in so redirect to home page with the return url
            return <Redirect to={{pathname: '/', state: {from: props.location}}}/>
        }
        if (rest.auth && rest.role.indexOf(localStorage.role) === -1) {
            if (localStorage.role === roles.ADMIN || localStorage.role === roles.USER || localStorage.role === roles.TRANSLATOR)
                return <Redirect to={{pathname: '/', state: {from: props.location}}}/>
        }
        // authorised so return component
        return <Component {...props} />
    }}/>
);
